type PanelState = {
  openId: string | null,
};

type PanelStateListener = (state: PanelState) => void;

class PanelManager {
  private static instance: PanelManager | null = null;

  private state: PanelState = {
    openId: null,
  };

  private subscribers: Set<PanelStateListener> = new Set();

  private closeMobileMenuCallback: (() => void) | null = null;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PanelManager {
    if (!PanelManager.instance) {
      PanelManager.instance = new PanelManager();
    }
    return PanelManager.instance;
  }

  subscribe(callback: PanelStateListener) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }

  registerCloseMobileMenu(callback: () => void) {
    this.closeMobileMenuCallback = callback;
    return () => {
      if (this.closeMobileMenuCallback === callback) {
        this.closeMobileMenuCallback = null;
      }
    };
  }

  private notify() {
    this.subscribers.forEach((callback) => {
      callback(this.state);
    });
  }

  toggle(id: string) {
    if (this.state.openId === id) {
      this.state.openId = null;
    } else {
      this.state.openId = id;
    }
    this.notify();
  }

  close() {
    this.state.openId = null;
    this.notify();
    this.closeMobileMenuCallback?.();
  }

  getState() {
    return { ...this.state };
  }

  clearSubscribers() {
    this.subscribers.clear();
  }

  clearCloseMobileMenuCallback() {
    this.closeMobileMenuCallback = null;
  }
}

export const panelManager = PanelManager.getInstance();

export const panelsClose = (): void => {
  panelManager.close();
};

export const closePanelOnNavigate = (): void => {
  panelManager.close();

  document.querySelectorAll('[data-panel-control]').forEach((el) => {
    el.setAttribute('data-panel-disabled', 'true');
  });
};
